(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slideshow = document.querySelector('[data-slideshow]');
    if (!slideshow) return;
  
    const track = slideshow.querySelector('.hero-slideshow__track');
    const slides = slideshow.querySelectorAll('.hero-slideshow__slide');
    const total = slides.length;
  
    if (total < 2) return;
  
    let index = 0;
  
    setInterval(() => {
      index = (index + 1) % total;
      track.style.transform = `translateX(-${index * 100}%)`;
    }, 4000);
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-content-panel"] && !Shopify.designMode) return;
  try {
    
// Content Panel Tab Switching by Panel ID
(function() {
  var section = document.querySelector('.content-panel-section');
  if (!section) return;
  var navItems = section.querySelectorAll('.content-panel__nav-item');
  var panels = section.querySelectorAll('.content-panel__content-wrapper');
  
  navItems.forEach(function(btn, idx) {
    btn.addEventListener('click', function() {
      var panelId = btn.getAttribute('data-panel-id');
      
      // Update navigation states
      navItems.forEach(function(b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        b.tabIndex = b === btn ? 0 : -1;
      });
      
      // Update panel visibility
      panels.forEach(function(panel) {
        var panelElementId = panel.getAttribute('id');
        var thisPanelId = panelElementId.replace('block-content-panel-', '');
        var isActive = thisPanelId === panelId;
        
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });
  
  // Set initial state
  panels.forEach(function(panel, i) {
    if (i === 0) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    } else {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
